import React from 'react';
import { LinkPlainExternal } from 'app_previous/elements/links/Link.plain';
import { Color, palette, setColor } from 'app_previous/styles/colors';

export interface SocialMediaShareProp {
  path: string;
  title: string;
  // TODO: After case studies is reworked, default color to black
  color?: Color;
}

export const FacebookShareLink = ({ path, color }: SocialMediaShareProp): JSX.Element => (
  <LinkPlainExternal
    href={`https://www.facebook.com/sharer/sharer.php?u=www.mightynetworks.com${path}`}
    target='_blank'
    rel='noreferrer'
  >
    <svg
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 0C1.34315 0 0 1.34315 0 3V29C0 30.6569 1.34315 32 3 32H15.1832V20.3782H11.5657C11.2534 20.3782 11 20.1136 11 19.7869V15.0192C11 14.6924 11.2531 14.4275 11.5657 14.4275H15.1832V11.1369C15.1832 6.80126 17.7953 4 21.8373 4L25.4351 4.00603C25.7472 4.00664 26 4.27123 26 4.59736V9.02446C26 9.35089 25.7469 9.61578 25.4346 9.61578L23.0109 9.61669C21.34 9.61669 21.0343 10.2973 21.0343 11.6381V14.4275H25.2654C25.4155 14.4275 25.5598 14.49 25.6658 14.601C25.7717 14.712 25.8314 14.8623 25.8314 15.0192L25.8297 19.7869C25.8297 20.1136 25.5766 20.3782 25.264 20.3782H21.0343V32H29C30.6569 32 32 30.6569 32 29V3C32 1.34315 30.6569 0 29 0H3Z'
        fill={color ? setColor(color) : palette.deepPurple}
      ></path>
    </svg>
  </LinkPlainExternal>
);

export const TwitterShareLink = ({ path, title, color }: SocialMediaShareProp): JSX.Element => (
  <LinkPlainExternal
    href={`https://twitter.com/intent/tweet?text=${title}&url=www.mightynetworks.com${path}`}
    target='_blank'
    rel='noopener noreferrer'
  >
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5256 7.747L16.4955 0.818237H15.0808L9.89726 6.83448L5.75711 0.818237H0.981934L7.2426 9.91578L0.981934 17.1817H2.39673L7.87082 10.8284L12.2431 17.1817H17.0183L10.5255 7.747H10.5259H10.5256ZM8.58791 9.99584L7.95354 9.08998L2.90641 1.88154H5.07932L9.15251 7.69897L9.78688 8.60483L15.0815 16.1666H12.9086L8.58804 9.99611V9.9957L8.58791 9.99584Z'
        fill={color ? setColor(color) : palette.deepPurple}
      />
    </svg>
  </LinkPlainExternal>
);

export const LinkedInShareLink = ({ path, title, color }: SocialMediaShareProp): JSX.Element => (
  <LinkPlainExternal
    href={`http://www.linkedin.com/shareArticle?mini=true&url=www.mightynetworks.com${path}&title=${title}`}
    target='_blank'
    rel='noopener noreferrer'
  >
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.75 0.25C23.6797 0.25 24.5 1.07031 24.5 2.05469V23C24.5 23.9844 23.6797 24.75 22.75 24.75H1.69531C0.765625 24.75 0 23.9844 0 23V2.05469C0 1.07031 0.765625 0.25 1.69531 0.25H22.75ZM7.38281 21.25V9.60156H3.77344V21.25H7.38281ZM5.57812 7.96094C6.72656 7.96094 7.65625 7.03125 7.65625 5.88281C7.65625 4.73438 6.72656 3.75 5.57812 3.75C4.375 3.75 3.44531 4.73438 3.44531 5.88281C3.44531 7.03125 4.375 7.96094 5.57812 7.96094ZM21 21.25V14.8516C21 11.7344 20.2891 9.27344 16.625 9.27344C14.875 9.27344 13.6719 10.2578 13.1797 11.1875H13.125V9.60156H9.67969V21.25H13.2891V15.5078C13.2891 13.9766 13.5625 12.5 15.4766 12.5C17.3359 12.5 17.3359 14.25 17.3359 15.5625V21.25H21Z'
        fill={color ? setColor(color) : palette.deepPurple}
      />
    </svg>
  </LinkPlainExternal>
);
